import React from 'react';
import { Code2, Sparkles, CheckCircle2 } from 'lucide-react';
import { Badge } from '../ui';

export const HeroTechnookVisual: React.FC = () => {
  return (
    <div className="relative w-full max-w-xl mx-auto flex justify-center items-center">
      {/* Background ambient glowing soft radial blur */}
      <div className="absolute -top-6 -right-6 w-64 h-64 sm:w-80 sm:h-80 bg-white/10 dark:bg-[#08adae]/20 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute -bottom-6 -left-6 w-64 h-64 sm:w-80 sm:h-80 bg-sky-400/10 dark:bg-[#4a82c2]/20 rounded-full blur-3xl pointer-events-none" />

      {/* Main Technook Angled Device Shield */}
      <div className="relative z-10 w-full p-5 sm:p-7 lg:p-9 rounded-2xl sm:rounded-3xl bg-white/95 dark:bg-[#0f1b2d]/90 border border-white/40 dark:border-[#4a82c2]/30 shadow-2xl backdrop-blur-2xl overflow-hidden group">
        
        {/* Dynamic Decorative Watermark Pattern */}
        <div className="absolute -bottom-10 -right-10 w-36 h-36 sm:w-48 sm:h-48 bg-gradient-to-br from-[#4a82c2]/20 to-transparent rounded-full blur-xl pointer-events-none" />

        <div className="space-y-4 sm:space-y-5 text-center sm:text-left relative z-10">
          
          {/* Top Emblem & Badge Header */}
          <div className="flex flex-wrap items-center justify-center sm:justify-start gap-2.5 sm:gap-3">
            <div className="p-2.5 sm:p-3 rounded-xl sm:rounded-2xl bg-gradient-to-br from-[#4a82c2] to-[#184166] text-white shadow-lg shadow-[#4a82c2]/30">
              <Code2 size={22} className="sm:w-7 sm:h-7" />
            </div>
            <div className="text-center sm:text-left">
              <span className="text-lg sm:text-2xl font-black text-[#184166] dark:text-white tracking-tight block leading-none">
                Tech<span className="text-[#4a82c2]">Nook</span>
              </span>
              <span className="text-[9px] sm:text-[11px] font-mono font-semibold text-[#08adae] tracking-wider uppercase">
                Solutions Engine
              </span>
            </div>
          </div>

          {/* Core Tagline */}
          <div className="space-y-1.5 sm:space-y-2 pt-2 border-t border-slate-200 dark:border-slate-800">
            <h3 className="text-base sm:text-xl lg:text-2xl font-extrabold text-[#184166] dark:text-white tracking-tight leading-snug">
              Solutions that Transform Life Easier.
            </h3>
            <div className="flex flex-wrap justify-center sm:justify-start gap-1.5 sm:gap-2 text-[10px] sm:text-[11px] font-mono text-[#4a82c2] dark:text-sky-300 font-semibold">
              <span>#TechNook</span>
              <span>#SoftwareDevelopment</span>
              <span>#SystemsEngineering</span>
            </div>
          </div>

          {/* Dynamic Capability Badges */}
          <div className="grid grid-cols-2 gap-2 sm:gap-2.5 pt-1">
            <div className="p-2.5 sm:p-3 rounded-xl bg-sky-50 dark:bg-[#09101d] border border-slate-200 dark:border-slate-800 space-y-0.5 sm:space-y-1">
              <span className="text-[9px] sm:text-[10px] uppercase font-bold text-slate-500 dark:text-slate-400 block">Efficiency</span>
              <span className="text-xs sm:text-sm font-black text-[#4a82c2] dark:text-sky-400 flex items-center justify-center sm:justify-start gap-1">
                <CheckCircle2 size={13} className="text-emerald-500 shrink-0" /> +45% Delivery
              </span>
            </div>

            <div className="p-2.5 sm:p-3 rounded-xl bg-teal-50 dark:bg-[#09101d] border border-slate-200 dark:border-slate-800 space-y-0.5 sm:space-y-1">
              <span className="text-[9px] sm:text-[10px] uppercase font-bold text-slate-500 dark:text-slate-400 block">System SLA</span>
              <span className="text-xs sm:text-sm font-black text-[#08adae] flex items-center justify-center sm:justify-start gap-1">
                <Sparkles size={13} className="text-[#08adae] shrink-0" /> 99.9% Uptime
              </span>
            </div>
          </div>

          {/* Social Proof Tags */}
          <div className="pt-2 flex flex-col sm:flex-row items-center justify-between gap-1.5 text-[11px] sm:text-xs text-slate-500 dark:text-slate-400 border-t border-slate-200 dark:border-slate-800">
            <span className="font-semibold text-slate-700 dark:text-slate-300">Parañaque HQ Operational</span>
            <Badge variant="accent" className="text-[9px] sm:text-[10px] px-2 py-0.5">
              Viber & WhatsApp Ready
            </Badge>
          </div>

        </div>
      </div>
    </div>
  );
};
